import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { getAllChapters } from "@/api/chapters";

const AnalyticsPage = () => {
  // Fetch public data - only chapters is public, others require authentication
  const {
    data: chapters,
    isLoading: chaptersLoading,
    error: chaptersError,
  } = useQuery({
    queryKey: ["chapters"],
    queryFn: getAllChapters,
  });

  // Note: Sponsorships, payments, and HAAF payments require authentication
  // For public view, we'll show placeholders or limited data

  const totalChapters = chapters?.length || 0;

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
          Taawun Payments Analytics
        </h1>
        <p className="text-center text-gray-600 mb-8">
          Public overview of Taawun's chapters, sponsorships, and payment
          activities.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Total Chapters</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold text-blue-600">
                {chaptersLoading
                  ? "..."
                  : chaptersError
                    ? "N/A"
                    : totalChapters}
              </div>
              <Badge variant="secondary" className="mt-2">
                Active Communities
              </Badge>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Total Sponsorships</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold text-green-600">
                Login Required
              </div>
              <Badge variant="secondary" className="mt-2">
                Children Supported
              </Badge>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Total Payments</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold text-purple-600">
                Login Required
              </div>
              <Badge variant="secondary" className="mt-2">
                Transactions Processed
              </Badge>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-lg">HAAF Payments</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold text-orange-600">
                Login Required
              </div>
              <Badge variant="secondary" className="mt-2">
                Humanitarian Aid
              </Badge>
            </CardContent>
          </Card>
        </div>

        {/* Placeholder for future charts or detailed data */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 mb-4">
            More detailed analytics and visualizations available after login.
          </p>
          <a href="/login" className="text-blue-600 hover:underline">
            Login to view full data
          </a>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPage;
